export const iconFontAwesomeWeatherCloudMeatball = (
	<i className="fa-solid fa-cloud-meatball"></i>
);
